module.exports = "/_next/static/images/Backup@2x-e586bb18aa0e2041a0174aac0cb2f9f8.png";